var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 16.0833H11.9166V12.2333L13.3833 13.7L14.6666 12.4167L11 8.75L7.33331 12.4167L8.61665 13.7L10.0833 12.2333V16.0833ZM3.66665 18.8333C3.16248 18.8333 2.73073 18.6537 2.3714 18.2943C2.01206 17.935 1.8327 17.5036 1.83331 17V6C1.83331 5.49583 2.01298 5.06408 2.37231 4.70475C2.73165 4.34542 3.16309 4.16606 3.66665 4.16667H9.16665L11 6H18.3333C18.8375 6 19.2692 6.17967 19.6286 6.539C19.9879 6.89833 20.1673 7.32978 20.1666 7.83333V17C20.1666 17.5042 19.987 17.9359 19.6276 18.2952C19.2683 18.6546 18.8369 18.8339 18.3333 18.8333H3.66665ZM3.66665 6V17H18.3333V7.83333H10.2437L8.4104 6H3.66665Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.17be1ae1461f75d88876db33c0ca7a99.svg";
export { ForwardRef as ReactComponent };